(function () {
	console.log("Browser detection script loaded");
  var ua = navigator.userAgent || "";
  var vendor = navigator.vendor || "";
  var isIpadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  var isiOS    = /iP(?:hone|ad|od)/.test(ua) || isIpadOS;

  // Desktop Safari (exclude Chromium, Edge, Opera)
  var isDesktopSafari =
    /Safari/i.test(ua) &&
    /Apple/i.test(vendor) &&
    !/(Chrome|Chromium|Edg|OPR)/i.test(ua);

  // iOS Safari (exclude Chrome/Firefox/Edge on iOS, which also use WebKit)
  var isIOSSafari =
    isiOS &&
    /Safari/i.test(ua) &&
    !/(CriOS|FxiOS|EdgiOS|OPiOS|OPT)/i.test(ua);

  if (isDesktopSafari || isIOSSafari) {
    document.documentElement.classList.add("is-safari");
  }
  if (isIOSSafari) {
    document.documentElement.classList.add("is-ios-safari");
  }
})();